export default __webpack_public_path__ + "static/media/discord.92ff56fd.svg";